import RentFormSlider from './RentFormSlider'

export default RentFormSlider
